import React from 'react';

import { ReactComponent as FinanceIcon } from 'assets/icons/finance.svg';

const AutoBuyInstructionContent = {
  title: "Set Up Automatic Buy; it’s as easy as 1-2-3.",
  subtitle: "Give your assets a greater potential for growth by investing regularly. Our Automatic Buy feature makes it simple to save. Prepare for tomorrow by automating today. You can adjust your amount and schedule at any time.",
  steps: [
    {
      content: "Select your funding source"
    },
    {
      content: "Pick your T. Rowe Price mutual fund"
    },
    {
      content: "Choose how much you want to invest and how often – we’ll take care of the rest!"
    }
  ],
  notes: [{
    content: "Save regularly by setting up Automatic Buy for all your T. Rowe Price accounts. Even $100 a month helps build a good investing habit.",
    icon: <FinanceIcon />
  }]
};

export default AutoBuyInstructionContent;
